import React from 'react';
import { Link } from 'react-router-dom';

function SuccessStories() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .stories-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Medical Tourism Success Stories: Real Private Hospital Outcomes in Delhi NCR
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          Reading documented recovery milestones from other international patients is one of the most reassuring steps when planning a healthcare trip overseas. Every year, thousands of global travelers journey to the Delhi National Capital Region (NCR)—including New Delhi, Gurgaon, and Noida—for complex private healthcare interventions.
        </p>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          By compiling public patient reviews and clinical track benchmarks on independent directories like <strong>Medical Trip World</strong>, families can analyze real-world case outlines, explore recovery milestones, and map out their international healthcare research safely.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(40,167,69,0.2)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free Private Cost Comparison Charts & Toolkits →
        </Link>
      </div>

      {/* SECTION 1: DETAILED PATIENT CASE STUDIES */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Documented International Patient Recovery Outcomes
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '20px', fontSize: '0.95rem' }}>
          These case overviews outline typical journeys of international consumers utilizing premier multi-specialty private hospital networks in the capital region to overcome severe health conditions:
        </p>

        {/* CASE 1: CARDIAC */}
        <div style={{ background: '#fafafa', padding: '20px', borderRadius: '6px', marginBottom: '20px', border: '1px solid #e2e8f0', borderLeft: '4px solid #005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.15rem', fontWeight: '700' }}>Case Study 1: Advanced Coronary Angioplasty (Patient from Oman)</h3>
          <p style={{ color: '#444', fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
            <strong>Condition & Vetting:</strong> A 54-year-old traveler presented with severe chest pain and multi-vessel blockages, looking at months-long waiting lines locally. He utilized independent directory archives to review certified private centers in Gurgaon. <br />
            <strong>Clinical Intervention:</strong> Upon landing on a specialized Medical Visa, premium private cardiothoracic teams executed a minimally invasive coronary angioplasty with drug-eluting clear stent placements inside a hybrid catheterization lab. <br />
            <strong>Outcome:</strong> The patient stayed inside the private facility for 3 days before transitioning to an outpatient recovery hotel, safely flying home on day 7 with normalized cardiovascular parameters.
          </p>
        </div>

        {/* CASE 2: ORTHOPEDICS */}
        <div style={{ background: '#fafafa', padding: '20px', borderRadius: '6px', marginBottom: '20px', border: '1px solid #e2e8f0', borderLeft: '4px solid #ff9f1c', boxSizing: 'border-box' }}>
          <h3 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.15rem', fontWeight: '700' }}>Case Study 2: Bilateral Robotic Knee Reconstruction (Patient from Kenya)</h3>
          <p style={{ color: '#444', fontSize: '0.95rem', lineHeight: '1.6', margin: '0' }}>
            <strong>Condition & Vetting:</strong> A retired educator suffered from advanced Stage-4 osteoarthritis, restricting her mobility completely. Faced with extreme local private surgery quotes, she cross-referenced global infrastructure ratings online. <br />
            <strong>Clinical Intervention:</strong> She selected a premier private hospital hub in New Delhi specializing in computerized optical navigation. Senior consultants executed a bilateral total knee replacement using high-flex, FDA-approved implants to balance joint ligaments accurately. <br />
            <strong>Outcome:</strong> Intensive rehabilitation began within 24 hours post-op via the private hospital’s specialized physiotherapy wing. Following a 5-day inpatient stay and 12 days of local outpatient monitoring, she regained full mobility.
          </p>
        </div>
      </section>

      {/* SECTION 2: STRUCTURAL MILESTONES MATRIX - SAFELY WRAPPED */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Average Recovery Timelines in Private Healthcare Systems
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Successful medical travel requires allocating appropriate time-blocks for post-discharge healing before air travel. Review standard structural timelines compiled from private clinical tracking data:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(12px, 4vw, 20px)', margin: '25px 0', borderRadius: '4px', borderLeft: '4px solid #28a745', border: '1px solid #e2e8f0', borderLeftColor: '#28a745', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#28a745', fontSize: '1.2rem', marginBottom: '10px' }}>📊 Standard Post-Op Travel Clearance Averages:</h3>
          
          {/* Scroll Protective Wrapper Box */}
          <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', margin: '15px 0 5px 0' }}>
            <table style={{ width: '100%', minWidth: '650px', borderCollapse: 'collapse', color: '#333', textAlign: 'left', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #ddd' }}>
                  <th style={{ padding: '10px 8px' }}>Specialty Procedure</th>
                  <th style={{ padding: '10px 8px' }}>Inpatient Days</th>
                  <th style={{ padding: '10px 8px' }}>Local Outpatient Days</th>
                  <th style={{ padding: '10px 8px' }}>Total Travel-Ready Window</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Coronary Angioplasty (PCI)</strong></td>
                  <td style={{ padding: '10px 8px' }}>2 - 3 Days</td>
                  <td style={{ padding: '10px 8px' }}>3 - 5 Days</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold' }}>5 - 8 Days total</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Total Joint Replacement</strong></td>
                  <td style={{ padding: '10px 8px' }}>4 - 5 Days</td>
                  <td style={{ padding: '10px 8px' }}>10 - 14 Days</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold' }}>14 - 20 Days total</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Autologous Bone Marrow Transplant</strong></td>
                  <td style={{ padding: '10px 8px' }}>30 - 45 Days</td>
                  <td style={{ padding: '10px 8px' }}>60 - 90 Days</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold' }}>90 - 120 Days total</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* SECTION 3: CORE SAFETY VERIFICATION - RESPONSIVE MOBILE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          How to Independently Audit Patient Safety Claims
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates exclusively as an open informational venue and independent index, we urge traveling families to verify clinic profiles directly using established international parameters:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Accreditation Directory Lookups</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Do not rely on web text badges alone. Verify that your chosen private hospital maintains active tracking credentials within the official Joint Commission International (JCI) or national NABH public directories.
            </p>
          </div>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Surgeon Performance History</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Request clear surgical logs or peer-reviewed publication data maps from your selected operating consultant to verify extensive familiarity with modern high-volume techniques.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e2e8f0', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem', fontWeight: '700' }}>
          Frequently Asked Questions (FAQs) – Treatment Outcomes & Safety
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Are clinical success rates at private hospitals in India on par with Western systems?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes. Re-certified corporate hospital networks in Delhi NCR utilize the exact same diagnostic infrastructure, operating parameters, and sterile processing checklists as elite private institutions in North America or Western Europe, aiming for highly favorable outcomes.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>How do international patients handle legal paperwork and consent tracking?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            All medical registration guidelines, risk acknowledgments, and informed clinical consent forms are provided in comprehensive English. Private hospital international support desks deliver native translation teams to ensure deep clarity before any procedure begins.
          </p>
        </div>
        
        <div style={{ marginBottom: '0' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Does Medical Trip World officially guarantee these success rates or manage admissions?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions exclusively as an independent informational directory and research portal. We do not provide clinical tracking, guarantee treatment outcomes, or hold formal corporate partnerships or Memorandums of Understanding (MOUs) with any private hospital system. All financial quotes, clinical consultations, and care contracts exist solely and directly between the patient and their self-selected healthcare professional.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/submit-query" className="stories-footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(40,167,69,0.15)' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="stories-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default SuccessStories;